const Marionette = require('lib/marionette')
const template = require('./anonymous_ledge_view.html')
const styles = require('./anonymous_ledge_view.less')
const viewport = require('module/viewport/viewport')
const radio = require('lib/radio')
const log = require('log').create('anonymous ledge') // eslint-disable-line

const metrics = radio.metrics_profile

const AnonymousLedgeView = Marionette.View.extend({

    displayName: 'AnonymousLedgeView',

    template,

    styles,

    onAttach() {
        // metrics.trigger('ledge:signup:shown')
    },

    ui: {
        button: '.button',
    },

    events: {
        'click': 'onClickLedge',
        'click @ui.button': 'onClickButton',
    },

    onClickLedge(e) {
        if (viewport.isNot('small')) return
        metrics.trigger('ledge:signup:clicked')
        window.location = '/welcome'
    },

    onClickButton() {
        metrics.trigger('ledge:signup:clicked')
    },

})

module.exports = AnonymousLedgeView
